import {
  keys, forEach, cloneDeep,
  reduce, map, find, includes,
  set, get, merge, isObject, toPairs,
  some, findIndex, filter, orderBy,
  isEqual,
} from 'lodash';
import sportIds from '@/services/helpers/sports';

const {
  HOCKEY_ID,
  BASKETBALL_ID,
  FOOTBALL_ID,
  BASEBALL_ID,
  TENNIS_ID,
  SOCCER_ID,
} = sportIds;

// ICE HOCKEY
export const createHockeyGlobalParams = () => ({
  periodOneDistribution: {
    shortName: 'p1distr',
    longName: 'Period one distribution',
    defaultValue: 1.0,
    raiseIncrement: 0.01,
    minValue: 0.01,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  periodTwoDistribution: {
    shortName: 'p2distr',
    longName: 'Period two distribution',
    defaultValue: 1.1,
    raiseIncrement: 0.01,
    minValue: 0.01,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  periodThreeDistribution: {
    shortName: 'p3distr',
    longName: 'Period three distribution',
    defaultValue: 1.0,
    raiseIncrement: 0.01,
    minValue: 0.01,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  overtimeDistribution: {
    shortName: 'OTdistr',
    longName: 'Overtime distribution',
    defaultValue: 2.17,
    raiseIncrement: 0.01,
    minValue: 0.01,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
});

export const createHockeyHomeTeamParams = () => ({
  scoreRateHome: {
    shortName: 'scrRate',
    longName: 'Score rate Home',
    defaultValue: 0.044,
    raiseIncrement: 0.0005,
    minValue: 0.001,
    maxValue: 0.999,
    isMain: true,
    showOnMultiviewList: true,
    numberOfDecimals: 4,
  },
  winBoostHome: {
    shortName: 'winBoost',
    longName: 'Win boost Home',
    defaultValue: 1.0,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  loseBoostHome: {
    shortName: 'loseBoost',
    longName: 'Lose boost Home',
    defaultValue: 1.0,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  powerPlayScoreRateFactorHome54: {
    shortName: 'PPscr 5v4',
    longName: 'Power play score rate factor Home 5v4',
    defaultValue: 2.5,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
    showOnMultiviewList: true,
  },
  powerPlayScoreRateFactorHome53: {
    shortName: 'PPscr 5v3',
    longName: 'Power play score rate factor Home 5v3',
    defaultValue: 7.2,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
    showOnMultiviewList: true,
  },
  powerPlayScoreRateFactorHome43: {
    shortName: 'PPscr 4v3',
    longName: 'Power play score rate factor Home 4v3',
    defaultValue: 6.5,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
    showOnMultiviewList: true,
  },
  emptyNetRemainingMinutesHomeD3: {
    shortName: 'emptyNet D3+',
    longName: 'Empty net remaining minutes Home D3',
    defaultValue: 0,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 20,
  },
  emptyNetRemainingMinutesHomeD2: {
    shortName: 'emptyNet D2',
    longName: 'Empty net remaining minutes Home D2',
    defaultValue: 2.5,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 10.0,
  },
  emptyNetRemainingMinutesHomeD1: {
    shortName: 'emptyNet D1',
    longName: 'Empty net remaining minutes Home D1',
    defaultValue: 1.5,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 10.0,
  },
  emptyNetScoreRatePowerFactorHome: {
    shortName: 'emptyNet Pwr Scr',
    longName: 'Empty net score rate power factor Home',
    defaultValue: 5.8,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
  },
  shootoutScoreProbabilityHome: {
    shortName: 'SOscr',
    longName: 'Shootout score probability Home',
    defaultValue: 0.33,
    raiseIncrement: 0.001,
    minValue: 0.001,
    maxValue: 0.999,
  },
  shotRateHome: {
    shortName: 'shotRateHome',
    longName: 'Shot rate Home',
    defaultValue: 0.47,
    raiseIncrement: 0.1,
    minValue: 0.002,
    maxValue: 2,
    numberOfDecimals: 4,
  },
  homePenaltyMinutes: {
    shortName: 'homePenaltyMinutes',
    longName: 'Home penalty minutes',
    defaultValue: 8,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 60,
  },

});

export const createHockeyAwayTeamParams = () => ({
  scoreRateAway: {
    shortName: 'scrRate',
    longName: 'Score rate Away',
    defaultValue: 0.044,
    raiseIncrement: 0.0005,
    minValue: 0.001,
    maxValue: 0.999,
    isMain: true,
    showOnMultiviewList: true,
    numberOfDecimals: 4,
  },
  winBoostAway: {
    shortName: 'winBoost',
    longName: 'Win boost Away',
    defaultValue: 1.0,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  loseBoostAway: {
    shortName: 'loseBoost',
    longName: 'Lose boost Away',
    defaultValue: 1.0,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 3.0,
    showOnMultiviewList: true,
  },
  powerPlayScoreRateFactorAway54: {
    shortName: 'PPscr 5v4',
    longName: 'Power play score rate factor Away 5v4',
    defaultValue: 2.5,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
    showOnMultiviewList: true,
  },
  powerPlayScoreRateFactorAway53: {
    shortName: 'PPscr 5v3',
    longName: 'Power play score rate factor Away 5v3',
    defaultValue: 7.2,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
    showOnMultiviewList: true,
  },
  powerPlayScoreRateFactorAway43: {
    shortName: 'PPscr 4v3',
    longName: 'Power play score rate factor Away 4v3',
    defaultValue: 6.5,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
    showOnMultiviewList: true,
  },
  emptyNetRemainingMinutesAwayD3: {
    shortName: 'emptyNet D3+',
    longName: 'Empty net remaining minutes Away D3',
    defaultValue: 0,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 20,
  },
  emptyNetRemainingMinutesAwayD2: {
    shortName: 'emptyNet D2',
    longName: 'Empty net remaining minutes Away D2',
    defaultValue: 2.5,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 10.0,
  },
  emptyNetRemainingMinutesAwayD1: {
    shortName: 'emptyNet D1',
    longName: 'Empty net remaining minutes Away D1',
    defaultValue: 1.5,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 10.0,
  },
  emptyNetScoreRatePowerFactorAway: {
    shortName: 'emptyNet Pwr Scr',
    longName: 'Empty net score rate power factor Away',
    defaultValue: 5.8,
    raiseIncrement: 0.1,
    minValue: 1.0,
    maxValue: 20.0,
  },
  shootoutScoreProbabilityAway: {
    shortName: 'SOscr',
    longName: 'Shootout score probability Away',
    defaultValue: 0.33,
    raiseIncrement: 0.001,
    minValue: 0.001,
    maxValue: 0.999,
  },
  shotRateAway: {
    shortName: 'shotRateAway',
    longName: 'Shot rate Away',
    defaultValue: 0.47,
    raiseIncrement: 0.1,
    minValue: 0.002,
    maxValue: 2,
    numberOfDecimals: 4,
  },
  awayPenaltyMinutes: {
    shortName: 'awayPenaltyMinutes',
    longName: 'Away penalty minutes',
    defaultValue: 8,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 60,
  },

});

export const createHockeyPlayerParams = () => ({
  goals: {
    key: 'goals',
    shortName: 'Goals',
    longName: 'Goals',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  assists: {
    key: 'assists',
    shortName: 'Assists',
    longName: 'Assists',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  saves: {
    key: 'saves',
    shortName: 'Saves',
    longName: 'Saves',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  shotsOnGoal: {
    key: 'shotsOnGoal',
    shortName: 'Shots',
    longName: 'Shots',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  lineupLine: {
    key: 'lineupLine',
    shortName: 'Lineup Line',
    longName: 'Lineup Line',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 5,
  },
  powerPlayAdjustment: {
    key: 'powerPlayAdjustment',
    shortName: 'PPadj',
    longName: 'Power play adjustment',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -0.5,
    maxValue: 0.5,
  },
});

const hockeyParamsManagerMarkets = (isUSAView) => ([
  {
    label: 'Moneyline',
    marketCode: 'RESULT',
    order: 1,
  },
  {
    label: 'Spread',
    marketCode: 'GOAL_HANDICAP',
    acceptNegative: true,
    order: 2,
  },
  {
    label: 'Total',
    marketCode: 'GOAL_OVER_UNDER',
    order: 3,
  },
  {
    label: 'Home Team Total',
    marketCode: 'TEAM_GOAL_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 5 : 4,
  },
  {
    label: 'Away Team Total',
    marketCode: 'TEAM_GOAL_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 4 : 5,
  },
  {
    label: '1st Period Moneyline',
    marketCode: 'PERIOD_RESULT',
    params: {
      PERIOD: 1,
    },
    order: 6,
  },
  {
    label: '2nd Period Moneyline',
    marketCode: 'PERIOD_RESULT',
    params: {
      PERIOD: 2,
    },
    order: 7,
  },
  {
    label: '3rd Period Moneyline',
    marketCode: 'PERIOD_RESULT',
    params: {
      PERIOD: 3,
    },
    order: 8,
  },
  {
    label: '1st Period Total',
    marketCode: 'PERIOD_GOAL_OVER_UNDER',
    params: {
      PERIOD: 1,
    },
    order: 9,
  },
  {
    label: '2nd Period Total',
    marketCode: 'PERIOD_GOAL_OVER_UNDER',
    params: {
      PERIOD: 2,
    },
    order: 10,
  },
  {
    label: '3rd Period Total',
    marketCode: 'PERIOD_GOAL_OVER_UNDER',
    params: {
      PERIOD: 3,
    },
    order: 11,
  },
]);

// BASKETBALL
// Changed to cruncher model type for all basketball competitions
// kept the functions in case we need to revert to random-walk model type
export const getBasketballGlobalParamsModelType = () => 'cruncher';
export const getBasketballGlobalParamsSportTypeByCompetition = () => 'basketball-cruncher';

export const createOPCEParam = (value) => ({
  shortName: 'OPCE',
  longName: 'OPCE',
  readonly: true,
  value: value ? parseFloat(value?.toFixed(2)) : 0,
});
export const createBasketballRandomWalkGlobalParams = () => ({
  mu: {
    shortName: 'MU',
    longName: 'Mean of distribution',
    defaultValue: 0.0370,
    raiseIncrement: 0.0001,
    minValue: 0.01,
    maxValue: 0.07,
    numberOfDecimals: 4,
  },
  intensityHome: {
    shortName: 'IntHome',
    longName: 'Intensity Home',
    defaultValue: 0.500,
    raiseIncrement: 0.005,
    minValue: 0.25,
    maxValue: 0.75,
  },
  comeback: {
    shortName: 'comeback',
    longName: 'Comeback',
    defaultValue: 0.090,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 0.25,
  },
  beta: {
    shortName: 'beta',
    longName: 'Beta',
    defaultValue: 0.001,
    raiseIncrement: 0.001,
    minValue: 0,
    maxValue: 0.02,
  },
  nq1: {
    shortName: 'NQ1',
    longName: '1st Quarter Distribution',
    defaultValue: 0.25,
    raiseIncrement: 0.01,
    minValue: 0.1,
    maxValue: 0.5,
  },
  nq2: {
    shortName: 'NQ2',
    longName: '2st Quarter Distribution',
    defaultValue: 0.25,
    raiseIncrement: 0.01,
    minValue: 0.1,
    maxValue: 0.5,
  },
  nq3: {
    shortName: 'NQ3',
    longName: '3st Quarter Distribution',
    defaultValue: 0.25,
    raiseIncrement: 0.01,
    minValue: 0.1,
    maxValue: 0.5,
  },
  homeTipOff: {
    shortName: 'Tipoff',
    longName: 'Home tip off',
    defaultValue: 0.5,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
});
export const createBasketballRandomWalkHomeTeamParams = () => ({
  homeThreePointersPercentage: {
    shortName: 'H3PT%',
    longName: 'Home three pointers percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.001,
    minValue: 0.01,
    maxValue: 0.99,
    isMain: true,
    showOnMultiviewList: true,
  },
});
export const createBasketballRandomWalkAwayTeamParams = () => ({
  awayThreePointersPercentage: {
    shortName: 'A3PT%',
    longName: 'Away three pointers percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.001,
    minValue: 0.01,
    maxValue: 0.99,
    isMain: true,
    showOnMultiviewList: true,
  },
});
export const createBasketballCruncherGlobalParams = () => ({
  paceByHalf: {
    shortName: 'PaceH',
    longName: 'Pace by half',
    defaultValue: 0.005,
    raiseIncrement: 0.001,
    minValue: -1,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  efficiencyByHalf: {
    shortName: 'effH',
    longName: 'Efficiency by half',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  freeThrowProbability: {
    shortName: 'Free Throw P',
    longName: 'Free throw probability',
    defaultValue: 0.77,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  homeFieldAdvantage: {
    shortName: 'Home field adv',
    longName: 'Home field advantage',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  ww: {
    shortName: 'ww',
    longName: 'WW',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  affectedLead: {
    shortName: 'aff lead',
    longName: 'Affected lead',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 50,
  },
  leverage: {
    shortName: 'leverage',
    longName: 'Leverage',
    defaultValue: 2.5,
    raiseIncrement: 0.1,
    minValue: 0,
    maxValue: 5,
  },
  homeTipOff: {
    shortName: 'Tipoff',
    longName: 'Home tip off',
    defaultValue: 0.5,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  q1Pace: {
    shortName: 'q1Pace',
    longName: 'Q1 pace',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  q3Pace: {
    shortName: 'q3Pace',
    longName: 'Q3 pace',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  efficiencyByQ1: {
    shortName: 'effQ1',
    longName: 'Efficiency by Q1',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
  },
  efficiencyByQ3: {
    shortName: 'effQ3',
    longName: 'Efficiency by Q3',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
  },
  disableSuspensionOnSpreadLineThreshold: {
    shortName: 'disableSuspensionOnSpreadLineThreshold',
    longName: 'Ignore Max Spread Threshold',
    defaultValue: false,
    type: 'boolean',
  },
});
export const createBasketballCruncherHomeTeamParams = () => ({
  homeTeamEfficiency: {
    shortName: 'homeEff',
    longName: 'Home team efficiency',
    defaultValue: 1.08,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeTeamPace: {
    shortName: 'homePace',
    longName: 'Home team pace',
    defaultValue: 0.98,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeTeamFoul: {
    shortName: 'homeFoul',
    longName: 'Home team foul',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeTeamVariance: {
    shortName: 'homeVariance',
    longName: 'Home team variance',
    defaultValue: 1.15,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeTeamFoulAggressiveness: {
    shortName: 'homeAggressiveness',
    longName: 'Home team foul aggressiveness',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeTeamUncertainty: {
    shortName: 'homeUncertainty',
    longName: 'Home team uncertainty',
    defaultValue: 0,
    raiseIncrement: 0.25,
    minValue: 0,
    maxValue: 3,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeTeamFoulOffset: {
    shortName: 'homeFoulOffset',
    longName: 'Home team foul offset',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: -3,
    maxValue: 3,
    isMain: true,
  },
  homeTeamTurnoverRate: {
    shortName: 'homeTurnoverRate',
    longName: 'Home team turnover rate',
    defaultValue: 0.25,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    isMain: true,
  },
  homeTeamAssistsFactor: {
    shortName: 'homeAssistsFactor',
    longName: 'Home team assists factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  homeTeamReboundsFactor: {
    shortName: 'homeReboundsFactor',
    longName: 'Home team rebounds factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  homeTeamThreesFactor: {
    shortName: 'homeThreesFactor',
    longName: 'Home team threes factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  homeTeamBlocksFactor: {
    shortName: 'homeBlocksFactor',
    longName: 'Home team blocks factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  homeTeamStealsFactor: {
    shortName: 'homeStealsFactor',
    longName: 'Home team steals factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
});
export const createBasketballCruncherAwayTeamParams = () => ({
  awayTeamEfficiency: {
    shortName: 'awayEff',
    longName: 'Away team efficiency',
    defaultValue: 1.08,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayTeamPace: {
    shortName: 'awayPace',
    longName: 'Away team pace',
    defaultValue: 0.98,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayTeamFoul: {
    shortName: 'awayFoul',
    longName: 'Away team foul',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayTeamVariance: {
    shortName: 'awayVariance',
    longName: 'Away team variance',
    defaultValue: 1.15,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayTeamFoulAggressiveness: {
    shortName: 'awayAggressiveness',
    longName: 'Away team foul aggressiveness',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayTeamUncertainty: {
    shortName: 'awayUncertainty',
    longName: 'Away team uncertainty',
    defaultValue: 0,
    raiseIncrement: 0.25,
    minValue: 0,
    maxValue: 3,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayTeamFoulOffset: {
    shortName: 'awayFoulOffset',
    longName: 'Away team foul offset',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: -3,
    maxValue: 3,
    isMain: true,
  },
  awayTeamTurnoverRate: {
    shortName: 'awayTurnoverRate',
    longName: 'Away team turnover rate',
    defaultValue: 0.25,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    isMain: true,
  },
  awayTeamAssistsFactor: {
    shortName: 'awayAssistsFactor',
    longName: 'Away team assists factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  awayTeamReboundsFactor: {
    shortName: 'awayReboundsFactor',
    longName: 'Away team rebounds factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  awayTeamThreesFactor: {
    shortName: 'awayThreesFactor',
    longName: 'Away team threes factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  awayTeamBlocksFactor: {
    shortName: 'awayBlocksFactor',
    longName: 'Away team blocks factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
  awayTeamStealsFactor: {
    shortName: 'awayStealsFactor',
    longName: 'Away team steals factor',
    defaultValue: 1,
    raiseIncrement: 0.1,
    minValue: 0.1,
    maxValue: 10,
    isMain: true,
  },
});

export const createBasketballPlayerParams = () => ({
  isStarter: {
    key: 'isStarter',
    shortName: 'Starter',
    longName: 'Starter',
    defaultValue: false,
    editableInCalculatedMode: true,
  },
  totalMinutes: {
    key: 'totalMinutes',
    shortName: 'Total Minutes',
    longName: 'Total Minutes',
    defaultValue: 0,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 48,
    editableInCalculatedMode: true,
    actionOnUpdate: 'calculateMinutesFromDistribution',
  },
  minutesUncertainty: {
    key: 'minutesUncertainty',
    shortName: 'Min U',
    longName: 'Minutes Uncertainty',
    defaultValue: 0,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 48,
    editableInCalculatedMode: true,
  },
  timeQ1: {
    key: 'timeQ1',
    shortName: 'Min Q1',
    longName: 'Min Q1',
    defaultValue: 0,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 12,
    editableInCalculatedMode: true,
  },
  timeQ1Percentage: {
    key: 'timeQ1Percentage',
    shortName: 'Min Q1 %',
    longName: 'Min Q1 %',
    defaultValue: 0,
    readonly: true,
  },
  timeQ2: {
    key: 'timeQ2',
    shortName: 'Min Q2',
    longName: 'Min Q2',
    defaultValue: 0,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 12,
    editableInCalculatedMode: true,
  },
  timeQ2Percentage: {
    key: 'timeQ2Percentage',
    shortName: 'Min Q2 %',
    longName: 'Min Q2 %',
    defaultValue: 0,
    readonly: true,
  },
  timeQ3: {
    key: 'timeQ3',
    shortName: 'Min Q3',
    longName: 'Min Q3',
    defaultValue: 0,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 12,
    editableInCalculatedMode: true,
  },
  timeQ3Percentage: {
    key: 'timeQ3Percentage',
    shortName: 'Min Q3 %',
    longName: 'Min Q3 %',
    defaultValue: 0,
    readonly: true,
  },
  timeQ4: {
    key: 'timeQ4',
    shortName: 'Min Q4',
    longName: 'Min Q4',
    defaultValue: 0,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 12,
    editableInCalculatedMode: true,
  },
  timeQ4Percentage: {
    key: 'timeQ4Percentage',
    shortName: 'Min Q4 %',
    longName: 'Min Q4 %',
    defaultValue: 0,
    readonly: true,
  },
  points: {
    key: 'points',
    shortName: 'Points',
    longName: 'Points',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
  },
  threes: {
    key: 'threes',
    shortName: 'Threes',
    longName: 'Threes',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
  },
  rebounds: {
    key: 'rebounds',
    shortName: 'Rebounds',
    longName: 'Rebounds',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
  },
  assists: {
    key: 'assists',
    shortName: 'Assists',
    longName: 'Assists',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
  },
  offensiveReboundPutbackBoost: {
    key: 'quarter4UsageBoost.offensiveReboundPutbackBoost',
    shortName: 'ORB Putback Boost',
    longName: 'Offensive rebound putback boost',
    updateKey: 'quarter4UsageBoost.offensiveReboundPutbackBoost',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
  },
  steals: {
    key: 'steals',
    shortName: 'Steals',
    longName: 'Steals',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 2,
  },
  blocks: {
    key: 'blocks',
    shortName: 'Blocks',
    longName: 'Blocks',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 2,
  },
});

const basketballParamsManagerMarkets = (isUSAView) => ([
  {
    label: 'Moneyline',
    marketCode: 'RESULT',
    order: 1,
  },
  {
    label: 'Spread',
    marketCode: 'POINT_HANDICAP',
    acceptNegative: true,
    order: 2,
  },
  {
    label: 'Total',
    marketCode: 'POINT_OVER_UNDER',
    order: 3,
  },
  {
    label: '1st Half Moneyline',
    marketCode: 'HALF_RESULT',
    params: {
      HALF: 1,
    },
    order: 4,
  },
  {
    label: '1st Half Total',
    marketCode: 'HALF_POINT_OVER_UNDER',
    params: {
      HALF: 1,
    },
    order: 5,
  },
  {
    label: '1st Half Spread',
    marketCode: 'HALF_POINT_HANDICAP',
    params: {
      HALF: 1,
    },
    acceptNegative: true,
    order: 6,
  },
  {
    label: 'Home Team Total',
    marketCode: 'TEAM_POINT_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 8 : 7,
  },
  {
    label: 'Away Team Total',
    marketCode: 'TEAM_POINT_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 7 : 8,
  },
  {
    label: 'Home Team Assists',
    marketCode: 'TEAM_ASSISTS_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 10 : 9,
  },
  {
    label: 'Away Team Assists',
    marketCode: 'TEAM_ASSISTS_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 9 : 10,
  },
  {
    label: 'Home Team Blocks',
    marketCode: 'TEAM_BLOCKS_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 12 : 11,
  },
  {
    label: 'Away Team Blocks',
    marketCode: 'TEAM_BLOCKS_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 11 : 12,
  },
  {
    label: 'Home Team Rebounds',
    marketCode: 'TEAM_REBOUNDS_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 14 : 13,
  },
  {
    label: 'Away Team Rebounds',
    marketCode: 'TEAM_REBOUNDS_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 13 : 14,
  },
  {
    label: 'Home Team Steals',
    marketCode: 'TEAM_STEALS_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 16 : 15,
  },
  {
    label: 'Away Team Steals',
    marketCode: 'TEAM_STEALS_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 15 : 16,
  },
  {
    label: 'Home Team Threes',
    marketCode: 'TEAM_THREES_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 18 : 17,
  },
  {
    label: 'Away Team Threes',
    marketCode: 'TEAM_THREES_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 17 : 18,
  },
]);

// AMERICAN FOOTBALL
export const createFootballGlobalParams = () => ({
  effByHalf: {
    shortName: 'effByHalf',
    longName: 'Efficiency by half',
    defaultValue: 0.0,
    raiseIncrement: 0.01,
    minValue: -1.0,
    maxValue: 1.0,
  },
  effScores: {
    shortName: 'effScores',
    longName: 'Efficiency scores',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 5,
  },
  paceByHalf: {
    shortName: 'paceByHalf',
    longName: 'Pace by half',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -0.5,
    maxValue: 0.5,
  },
  paceRatio: {
    shortName: 'paceRatio',
    longName: 'Pace ratio',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  totalAdj: {
    shortName: 'totalAdj',
    longName: 'Total adjustement',
    defaultValue: 0,
    raiseIncrement: 0.1,
    minValue: -10,
    maxValue: 10,
  },
  homeFieldAdvantage: {
    shortName: 'homeFieldAdv',
    longName: 'Home field advantage',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -9,
    maxValue: 9,
  },
  coinFlip: {
    shortName: 'coinFlip',
    longName: 'Coin flip probability',
    defaultValue: 0.5,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  overrideEventState: {
    longName: 'Override Event State',
    defaultValue: false,
    type: 'boolean',
    availableInMatchStates: ['LIVE'],
  },
  overrideDownNumber: {
    shortName: 'down',
    longName: 'Override down number',
    defaultValue: 1,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 4,
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overrideYardsToWinDown: {
    shortName: 'ytg',
    longName: 'Override yards to win down',
    defaultValue: 1,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 50,
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overrideYardsToEndZone: {
    shortName: 'ytt',
    longName: 'Override yards to end zone',
    defaultValue: 1,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 99,
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overridePossession: {
    shortName: 'In possesion',
    longName: 'Override possesion',
    options: [
      {
        label: 'Away',
        value: 'AWAY',
      },
      {
        label: 'Home',
        value: 'HOME',
      },
    ],
    type: 'text-toggle',
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overrideQuarter: {
    shortName: 'quarter',
    longName: 'Current Quarter',
    defaultValue: 'IN_FIRST_PERIOD',
    type: 'select',
    options: [
      { label: 'Q1', value: 'IN_FIRST_PERIOD' },
      { label: 'Q2', value: 'IN_SECOND_PERIOD' },
      { label: 'Q3', value: 'IN_THIRD_PERIOD' },
      { label: 'Q4', value: 'IN_FOURTH_PERIOD' },
      { label: 'HT', value: 'AT_HALF_TIME' },
      { label: 'OT', value: 'IN_OVERTIME' },
    ],
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overrideRemainingTimeInQuarterSeconds: {
    shortName: 'timeLeft',
    longName: 'Time left in period (seconds)',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 900,
    numberOfDecimals: 0,
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overrideHomeTimeouts: {
    shortName: 'homeTO',
    longName: 'Home Timeouts',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 3,
    numberOfDecimals: 0,
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
  overrideAwayTimeouts: {
    shortName: 'awayTO',
    longName: 'Away Timeouts',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 3,
    numberOfDecimals: 0,
    availableInMatchStates: ['LIVE'],
    conditionalDisplay: 'overrideEventState',
  },
});

export const FOOTBALL_QUARTER_MAX_SECONDS = 900;
export const FOOTBALL_OVERTIME_MAX_SECONDS = 600;

export const getFootballOverrideRemainingTimeMax = (quarter) => (
  quarter === 'IN_OVERTIME' ? FOOTBALL_OVERTIME_MAX_SECONDS : FOOTBALL_QUARTER_MAX_SECONDS
);

export const getFootballOverrideValuesFromEventState = (eventState) => {
  if (!eventState) {
    return {
      overrideQuarter: 'IN_FIRST_PERIOD',
      overrideRemainingTimeInQuarterSeconds: 0,
      overrideHomeTimeouts: 0,
      overrideAwayTimeouts: 0,
      overrideDownNumber: 0,
      overrideYardsToWinDown: 0,
      overrideYardsToEndZone: 0,
      overridePossession: 'HOME',
    };
  }

  const validQuarters = [
    'IN_FIRST_PERIOD',
    'IN_SECOND_PERIOD',
    'IN_THIRD_PERIOD',
    'IN_FOURTH_PERIOD',
    'IN_OVERTIME',
  ];
  const period = includes(validQuarters, eventState.period)
    ? eventState.period
    : 'IN_FIRST_PERIOD';
  const quarterDuration = eventState.quarterDuration || 0;
  const overtimeDuration = eventState.overtimeDuration || 0;
  const gameTimeElapsedInPeriod = eventState.gameTimeElapsedInPeriod || 0;
  const totalDuration = period === 'IN_OVERTIME' ? overtimeDuration : quarterDuration;
  const remainingTime = Math.max(0, totalDuration - gameTimeElapsedInPeriod);
  const maxRemainingTime = getFootballOverrideRemainingTimeMax(period);
  const downNumber = eventState.downNumber || 0;
  const yardsToWinDown = eventState.yardsToWinDown || 0;
  const yardsToEndZone = eventState.yardsToEndZone || 0;
  const possession = eventState.inPossession || 'HOME';

  return {
    overrideQuarter: period,
    overrideDownNumber: downNumber,
    overrideYardsToWinDown: yardsToWinDown,
    overrideYardsToEndZone: yardsToEndZone,
    overridePossession: possession,
    overrideRemainingTimeInQuarterSeconds: Math.min(remainingTime, maxRemainingTime),
    overrideHomeTimeouts: eventState.home?.timeoutsLeft ?? eventState.homeTimeoutsLeft ?? 0,
    overrideAwayTimeouts: eventState.away?.timeoutsLeft ?? eventState.awayTimeoutsLeft ?? 0,
  };
};

export const footballOverrideParamKeys = [
  'overrideEventState',
  'overrideDownNumber',
  'overrideYardsToWinDown',
  'overrideYardsToEndZone',
  'overridePossession',
  'overrideQuarter',
  'overrideRemainingTimeInQuarterSeconds',
  'overrideHomeTimeouts',
  'overrideAwayTimeouts',
];
export const createFootballHomeTeamParams = () => ({
  homeSuccessRate: {
    shortName: 'successRate',
    longName: 'Home success rate',
    defaultValue: 0.7,
    raiseIncrement: 0.005,
    minValue: 0.3,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  homeYardsPerFirst: {
    shortName: 'yardsPerFirst',
    longName: 'Home yards per first',
    defaultValue: 17,
    raiseIncrement: 0.1,
    minValue: 10.1,
    maxValue: 30,
    showOnMultiviewList: true,
  },
  homeTurnoverFactor: {
    shortName: 'TOFactor',
    longName: 'Home turnover factor',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
  },
  homeFourthDownAggression: {
    shortName: '4thdownAgg',
    longName: 'Home fourth down aggression',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0.6,
    maxValue: 2,
  },
  homeFg33: {
    shortName: 'fg33',
    longName: 'Home field goal 33',
    defaultValue: 0.94,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  homeFg50: {
    shortName: 'fg50',
    longName: 'Home field goal 50',
    defaultValue: 0.75,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  homePuntDistance: {
    shortName: 'puntDist',
    longName: 'Home punt distance',
    defaultValue: 0,
    raiseIncrement: 0.1,
    minValue: -20,
    maxValue: 20,
  },
  homePuntFgYardLine: {
    shortName: 'puntFgYardL',
    longName: 'Home punt field goal yard line',
    defaultValue: 40,
    raiseIncrement: 1,
    minValue: 20,
    maxValue: 50,
  },
  homeSecsPerPlay: {
    shortName: 'secsPerPlay',
    longName: 'Home seconds per play',
    defaultValue: 1.02,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 1.5,
    showOnMultiviewList: true,
  },
  homeP2pt: {
    shortName: 'p2pt',
    longName: 'Home probability 2 point conversion',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  homeEffQ3: {
    shortName: 'effQ3',
    longName: 'Home efficiency Q3',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 1.5,
  },
  homeEffQ4: {
    shortName: 'effQ4',
    longName: 'Home efficiency Q4',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 1.5,
  },
  homeGoForIt: {
    shortName: 'goForIt',
    longName: 'Home go for it',
    defaultValue: -1,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  homeLastDriveEff: {
    shortName: 'lastDriveEff',
    longName: 'Home last drive eff',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -0.5,
    maxValue: 0.5,
  },
  homeUncertainty: {
    shortName: 'UC',
    longName: 'Home uncertainty',
    defaultValue: 1.5,
    raiseIncrement: 0.25,
    minValue: 0,
    maxValue: 6,
  },
});
export const createFootballAwayTeamParams = () => ({
  awaySuccessRate: {
    shortName: 'successRate',
    longName: 'Away success rate',
    defaultValue: 0.7,
    raiseIncrement: 0.005,
    minValue: 0.3,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  awayYardsPerFirst: {
    shortName: 'yardsPerFirst',
    longName: 'Away yards per first',
    defaultValue: 17,
    raiseIncrement: 0.1,
    minValue: 10.1,
    maxValue: 30,
    showOnMultiviewList: true,
  },
  awayTurnoverFactor: {
    shortName: 'TOFactor',
    longName: 'Away turnover factor',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
  },
  awayFourthDownAggression: {
    shortName: '4thdownAgg',
    longName: 'Away fourth down aggression',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0.6,
    maxValue: 2,
  },
  awayFg33: {
    shortName: 'fg33',
    longName: 'Away field goal 33',
    defaultValue: 0.94,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  awayFg50: {
    shortName: 'fg50',
    longName: 'Away field goal 50',
    defaultValue: 0.75,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  awayPuntDistance: {
    shortName: 'puntDist',
    longName: 'Away punt distance',
    defaultValue: 0,
    raiseIncrement: 0.1,
    minValue: -20,
    maxValue: 20,
  },
  awayPuntFgYardLine: {
    shortName: 'puntFgYardL',
    longName: 'Away punt field goal yard line',
    defaultValue: 40,
    raiseIncrement: 1,
    minValue: 20,
    maxValue: 50,
  },
  awaySecsPerPlay: {
    shortName: 'secsPerPlay',
    longName: 'Away seconds per play',
    defaultValue: 1.02,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 1.5,
    showOnMultiviewList: true,
  },
  awayP2pt: {
    shortName: 'p2pt',
    longName: 'Away probability 2 point conversion',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  awayEffQ3: {
    shortName: 'effQ3',
    longName: 'Away efficiency Q3',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 1.5,
  },
  awayEffQ4: {
    shortName: 'effQ4',
    longName: 'Away efficiency Q4',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 1.5,
  },
  awayGoForIt: {
    shortName: 'goForIt',
    longName: 'Away go for it',
    defaultValue: -1,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  awayLastDriveEff: {
    shortName: 'lastDriveEff',
    longName: 'Away last drive eff',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -0.5,
    maxValue: 0.5,
  },
  awayUncertainty: {
    shortName: 'UC',
    longName: 'Away uncertainty',
    defaultValue: 1.5,
    raiseIncrement: 0.25,
    minValue: 0,
    maxValue: 6,
  },
});
const footballParamsManagerMarkets = (isUSAView) => ([
  {
    label: 'Moneyline',
    marketCode: 'RESULT',
    order: 1,
  },
  {
    label: 'Spread',
    marketCode: 'POINT_HANDICAP',
    acceptNegative: true,
    order: 2,
  },
  {
    label: 'Total',
    marketCode: 'POINT_OVER_UNDER',
    order: 3,
  },
  {
    label: '1st Half Moneyline',
    marketCode: 'HALF_RESULT',
    params: {
      HALF: 1,
    },
    order: 4,
  },
  {
    label: '1st Half Total',
    marketCode: 'HALF_POINT_OVER_UNDER',
    params: {
      HALF: 1,
    },
    order: 5,
  },
  {
    label: '1st Half Spread',
    marketCode: 'HALF_POINT_HANDICAP',
    params: {
      HALF: 1,
    },
    acceptNegative: true,
    order: 6,
  },
  {
    label: 'Home Team Total',
    marketCode: 'TEAM_POINT_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 8 : 7,
  },
  {
    label: 'Away Team Total',
    marketCode: 'TEAM_POINT_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 7 : 8,
  },
  {
    label: '2nd Half Moneyline',
    marketCode: 'HALF_RESULT',
    params: {
      HALF: 2,
    },
    order: 9,
  },
  {
    label: '2nd Half Total',
    marketCode: 'HALF_POINT_OVER_UNDER',
    params: {
      HALF: 2,
    },
    order: 10,
  },
  {
    label: '2nd Half Spread',
    marketCode: 'HALF_POINT_HANDICAP',
    params: {
      HALF: 2,
    },
    acceptNegative: true,
    order: 11,
  },
  {
    label: 'Total Touchdowns',
    marketCode: 'TOUCHDOWN_OVER_UNDER',
    order: 12,
  },
  {
    label: 'Home Team Total Touchdowns',
    marketCode: 'TEAM_TOUCHDOWN_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 14 : 13,
  },
  {
    label: 'Away Team Total Touchdowns',
    marketCode: 'TEAM_TOUCHDOWN_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 13 : 14,
  },
  {
    label: 'Total Field Goals',
    marketCode: 'FIELD_GOAL_OVER_UNDER',
    order: 15,
  },
  {
    label: 'Home Team Total Field Goals',
    marketCode: 'TEAM_FIELD_GOAL_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 17 : 16,
  },
  {
    label: 'Away Team Total Field Goals',
    marketCode: 'TEAM_FIELD_GOAL_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 16 : 17,
  },
  {
    label: 'Total Punts',
    marketCode: 'PUNT_OVER_UNDER',
    order: 18,
  },
]);
export const createAFPlayerQuarterbackParams = () => ({
  passingRunningRatio: {
    key: 'passingRunningRatio',
    shortName: 'Passing running ratio',
    longName: 'Passing running ratio',
    defaultValue: 0.57,
    raiseIncrement: 0.01,
    minValue: 0.37,
    maxValue: 0.67,
  },
  passingTouchdownFactor: {
    key: 'passingTouchdownFactor',
    shortName: 'Passing TD factor',
    longName: 'Passing touchdown factor',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
  },
  passingCompletionFactor: {
    key: 'passingCompletionFactor',
    shortName: 'Passing comp factor',
    longName: 'Passing completion factor',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -1,
    maxValue: 1,
  },
  passingYardsFactor: {
    key: 'passingYardsFactor',
    shortName: 'Passing yards factor',
    longName: 'Passing yards factor',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 2,
  },
  interceptionTurnoverRatio: {
    key: 'interceptionTurnoverRatio',
    shortName: 'Interception turnover ratio',
    longName: 'Interception turnover ratio',
    defaultValue: 0.585,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runShortNoScore: {
    key: 'runShortNoScore',
    shortName: 'Run short no score',
    longName: 'Run short no score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runLongNoScore: {
    key: 'runLongNoScore',
    shortName: 'Run long no score',
    longName: 'Run long no score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runShortScore: {
    key: 'runShortScore',
    shortName: 'Run short score',
    longName: 'Run short score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runLongScore: {
    key: 'runLongScore',
    shortName: 'Run long score',
    longName: 'Run long score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
});

export const createAFPlayerNonQuarterbackParams = () => ({
  receiveShortNoScore: {
    key: 'receiveShortNoScore',
    shortName: 'Receive short no score',
    longName: 'Receive short no score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  receiveLongNoScore: {
    key: 'receiveLongNoScore',
    shortName: 'Receive long no score',
    longName: 'Receive long no score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  receiveShortScore: {
    key: 'receiveShortScore',
    shortName: 'Receive short score',
    longName: 'Receive short score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  receiveLongScore: {
    key: 'receiveLongScore',
    shortName: 'Receive long score',
    longName: 'Receive long score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runShortNoScore: {
    key: 'runShortNoScore',
    shortName: 'Run short no score',
    longName: 'Run short no score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runLongNoScore: {
    key: 'runLongNoScore',
    shortName: 'Run long no score',
    longName: 'Run long no score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runShortScore: {
    key: 'runShortScore',
    shortName: 'Run short score',
    longName: 'Run short score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  runLongScore: {
    key: 'runLongScore',
    shortName: 'Run long score',
    longName: 'Run long score',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
});

export const createAFPlayerDefensiveParams = () => ({
  interception: {
    key: 'interception',
    shortName: 'Interception',
    longName: 'Interception',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  sack: {
    key: 'sack',
    shortName: 'Sack',
    longName: 'Sack',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  tackle: {
    key: 'tackle',
    shortName: 'Tackle',
    longName: 'Tackle',
    defaultValue: 0,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 1,
  },
});

export const getAFMarketCodesByType = ({
  markets, availableMarketsPlayerTypes, isQuarterback, isOffensiveNonQB, isKicker,
}) => filter(markets, (market) => includes(availableMarketsPlayerTypes[market.marketCode], (
  // eslint-disable-next-line no-nested-ternary
  isQuarterback ? 'QUARTERBACK' : isOffensiveNonQB ? 'OFFENSIVE_NON_QB' : isKicker ? 'KICKER' : 'DEFENSIVE'
))) || [];

// BASEBALL
export const createBaseballGlobalParams = (isCalculatedMode) => ({
  weatherData: {
    rhoStart: {
      shortName: 'app',
      longName: 'APP RHO Start',
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 3,
      readonly: true,
    },
    rhoStartManual: {
      shortName: 'manual',
      longName: 'Manual RHO Start',
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 3,
      customMappableKey: 'weatherData.rhoStart',
      readonly: isCalculatedMode,
    },
    rhoEnd: {
      shortName: 'app',
      longName: 'APP RHO End',
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 3,
      readonly: true,
    },
    rhoEndManual: {
      shortName: 'manual',
      longName: 'Manual RHO End',
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 3,
      customMappableKey: 'weatherData.rhoEnd',
      readonly: isCalculatedMode,
    },
  },
  homeRunRate: {
    shortName: 'hrr',
    longName: 'Home run rate',
    defaultValue: 0.034,
    raiseIncrement: 0.001,
    minValue: 0,
    maxValue: 1,
    readonly: isCalculatedMode,
  },
  useHomeRunRate: {
    defaultValue: true,
    label: 'Use home run rate',
    type: 'boolean',
    readonly: isCalculatedMode,
  },
  parkId: {
    shortName: 'parkId',
    type: 'select',
    readonly: isCalculatedMode,
  },
  priceMicros: {
    shortName: 'priceMicros',
  },
  projections: {
    league: {
      title: {
        text: 'League',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
    park: {
      title: {
        text: 'Park',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: -1,
        maxValue: 1,
        updateKey: 'walkProbability',
        numberOfDecimals: 4,
        acceptNegative: true,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: -1,
        maxValue: 1,
        updateKey: 'strikeoutProbability',
        numberOfDecimals: 4,
        acceptNegative: true,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: -1,
        maxValue: 1,
        updateKey: 'singleProbability',
        numberOfDecimals: 4,
        acceptNegative: true,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: -1,
        maxValue: 1,
        updateKey: 'doubleOrTripleProbability',
        numberOfDecimals: 4,
        acceptNegative: true,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: -1,
        maxValue: 1,
        updateKey: 'homeRunProbability',
        numberOfDecimals: 4,
        acceptNegative: true,
      },
    },
    homeTeam: {
      title: {
        text: 'Home',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
    awayTeam: {
      title: {
        text: 'Away',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
    leftieToLeftie: {
      title: {
        text: 'Leftie to Leftie',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
    leftieToRightie: {
      title: {
        text: 'Leftie to Rightie',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
    rightieToRightie: {
      title: {
        text: 'Rightie to Rightie',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
    rightieToLeftie: {
      title: {
        text: 'Rightie to Leftie',
        nonMappable: true,
      },
      walkProb: {
        shortName: 'walk p',
        longName: 'Walk probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      strikeOutProb: {
        shortName: 'strkout p',
        longName: 'Strike out probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      singleProb: {
        shortName: 'single p',
        longName: 'Single probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      doubleOrTripleProb: {
        shortName: 'd or t p',
        longName: 'Double or triple probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
      homeRunProb: {
        shortName: 'hr p',
        longName: 'Home run probability',
        defaultValue: 0,
        raiseIncrement: 0.001,
        minValue: 0,
        maxValue: 1,
      },
    },
  },
  overrideLineup: {
    shortName: 'overrideLineup',
  },
  lineupNumberOverride: {
    shortName: 'lineupNumberOverride',
  },
});
export const createBaseballHomeTeamParams = () => ({
  pitcherAdjustments: {
    homeStarting: {
      shortName: 'Home s',
      longName: 'Home starting',
      defaultValue: 1,
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 2,
    },
    homeRelief: {
      shortName: 'Home r',
      longName: 'Home relief',
      defaultValue: 1,
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 2,
    },
  },
  uncertainty: {
    home: {
      shortName: 'uncertain h',
      longName: 'Home uncertainty',
      defaultValue: 1,
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 6,
    },
  },
});
export const createBaseballAwayTeamParams = () => ({
  pitcherAdjustments: {
    awayStarting: {
      shortName: 'Away s',
      longName: 'Away starting',
      defaultValue: 1,
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 2,
    },
    awayRelief: {
      shortName: 'Away r',
      longName: 'Away relief',
      defaultValue: 1,
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 2,
    },
  },
  uncertainty: {
    away: {
      shortName: 'Uncertain a',
      longName: 'Away uncertainty',
      defaultValue: 1,
      raiseIncrement: 0.01,
      minValue: 0,
      maxValue: 6,
    },
  },
});
const baseballParamsManagerMarkets = (isUSAView) => ([
  {
    label: 'Moneyline',
    marketCode: 'RESULT',
    order: 1,
  },
  {
    label: 'Spread',
    marketCode: 'RUN_HANDICAP',
    acceptNegative: true,
    order: 2,
  },
  {
    label: 'Total',
    marketCode: 'RUN_OVER_UNDER',
    order: 3,
  },
  {
    label: 'Home Team Total',
    marketCode: 'TEAM_RUN_OVER_UNDER',
    params: {
      TEAM: 0,
    },
    order: isUSAView ? 5 : 4,
  },
  {
    label: 'Away Team Total',
    marketCode: 'TEAM_RUN_OVER_UNDER',
    params: {
      TEAM: 1,
    },
    order: isUSAView ? 4 : 5,
  },
  {
    label: '1st Half ML',
    marketCode: 'RESULT_AFTER',
    params: {
      RESULT_AFTER_X: 5,
    },
    order: 6,
  },
  {
    label: '1st Half Total',
    marketCode: 'RUN_OVER_UNDER_AFTER',
    params: {
      RESULT_AFTER_X: 5,
    },
    order: 7,
  },
  {
    label: '1st Half Spread',
    marketCode: 'RUN_HANDICAP_AFTER',
    params: {
      RESULT_AFTER_X: 5,
    },
    order: 7,
  },
]);

export const createBaseballPlayerPitcherParams = () => ({
  isCurrentPitcher: {
    key: 'isCurrentPitcher',
    shortName: 'is current p',
    longName: 'Is current pitcher',
    defaultValue: false,
  },
  isNextPitcher: {
    key: 'isNextPitcher',
    shortName: 'is next p',
    longName: 'Is next pitcher',
    defaultValue: false,
  },
  maxPitchCount: {
    key: 'maxPitchCount',
    shortName: 'max pitch c',
    longName: 'Max pitch count',
    defaultValue: 30,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 500,
  },
  reliefPitcherOrder: {
    key: 'reliefPitcherOrder',
    shortName: 'r pitch order',
    longName: 'Relief pitcher order',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 1,
    maxValue: 50,
  },
  leftHandedHomeRunProb: {
    key: 'leftHandedHomeRunProb',
    shortName: 'slhr',
    longName: 'Left handed home run prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.homeRunProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedStrikeOutProb: {
    key: 'leftHandedStrikeOutProb',
    shortName: 'slk',
    longName: 'Left handed strike out prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.strikeOutProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedSingleProb: {
    key: 'leftHandedSingleProb',
    shortName: 'slsing',
    longName: 'Left handed single prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.singleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedDoubleOrTripleProb: {
    key: 'leftHandedDoubleOrTripleProb',
    shortName: 'slxb',
    longName: 'Left handed double or triple prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.doubleOrTripleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedWalkProb: {
    key: 'leftHandedWalkProb',
    shortName: 'lbb',
    longName: 'Left handed walk prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.walkProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedHomeRunProb: {
    key: 'rightHandedHomeRunProb',
    shortName: 'srhr',
    longName: 'Right handed home run prob ',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.homeRunProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedStrikeOutProb: {
    key: 'rightHandedStrikeOutProb',
    shortName: 'srk',
    longName: 'Right handed strike out prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.strikeOutProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedSingleProb: {
    key: 'rightHandedSingleProb',
    shortName: 'srsing',
    longName: 'Right handed single prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.singleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedDoubleOrTripleProb: {
    key: 'rightHandedDoubleOrTripleProb',
    shortName: 'srxb',
    longName: 'Right handed double or triple prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.doubleOrTripleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedWalkProb: {
    key: 'rightHandedWalkProb',
    shortName: 'rbb',
    longName: 'Right handed walk prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.walkProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  againstRightHandedEff: {
    key: 'againstRightHandedEff',
    shortName: 'srw %',
    longName: 'Against right handed %',
    defaultValue: 0,
    readonly: true,
  },
  againstLeftHandedEff: {
    key: 'againstLeftHandedEff',
    shortName: 'slw %',
    longName: 'Against left handed %',
    defaultValue: 0,
    readonly: true,
  },
});

export const createBaseballPlayerHitterParams = () => ({
  isCatcher: {
    key: 'isCatcher',
    shortName: 'is catcher',
    longName: 'Is catcher',
    defaultValue: false,
  },
  lineupNumber: {
    key: 'lineupNumber',
    shortName: 'lineup num',
    longName: 'Lineup number',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 1,
    maxValue: 50,
  },
  leftHandedHomeRunProb: {
    key: 'leftHandedHomeRunProb',
    shortName: 'slhr',
    longName: 'Left handed home run prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.homeRunProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedStrikeOutProb: {
    key: 'leftHandedStrikeOutProb',
    shortName: 'slk',
    longName: 'Left handed strike out prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.strikeOutProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedSingleProb: {
    key: 'leftHandedSingleProb',
    shortName: 'slsing',
    longName: 'Left handed single prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.singleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedDoubleOrTripleProb: {
    key: 'leftHandedDoubleOrTripleProb',
    shortName: 'slxb',
    longName: 'Left handed double or triple prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.doubleOrTripleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  leftHandedWalkProb: {
    key: 'leftHandedWalkProb',
    shortName: 'lbb',
    longName: 'Left handed walk prob',
    defaultValue: 0,
    updateKey: 'leftHandedProjection.walkProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedHomeRunProb: {
    key: 'rightHandedHomeRunProb',
    shortName: 'srhr',
    longName: 'Right handed home run prob ',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.homeRunProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedStrikeOutProb: {
    key: 'rightHandedStrikeOutProb',
    shortName: 'srk',
    longName: 'Right handed strike out prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.strikeOutProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedSingleProb: {
    key: 'rightHandedSingleProb',
    shortName: 'srsing',
    longName: 'Right handed single prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.singleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedDoubleOrTripleProb: {
    key: 'rightHandedDoubleOrTripleProb',
    shortName: 'srxb',
    longName: 'Right handed double or triple prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.doubleOrTripleProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  rightHandedWalkProb: {
    key: 'rightHandedWalkProb',
    shortName: 'rbb',
    longName: 'Right handed walk prob',
    defaultValue: 0,
    updateKey: 'rightHandedProjection.walkProb',
    minValue: 0,
    maxValue: 100,
    raiseIncrement: 0.005,
  },
  againstRightHandedEff: {
    key: 'againstRightHandedEff',
    shortName: 'srw %',
    longName: 'Against right handed %',
    defaultValue: 0,
    readonly: true,
  },
  againstLeftHandedEff: {
    key: 'againstLeftHandedEff',
    shortName: 'slw %',
    longName: 'Against left handed %',
    defaultValue: 0,
    readonly: true,
  },
  pinchHitRisk: {
    key: 'pinchHitRisk',
    shortName: 'Pinch hit risk',
    longName: 'Pinch hit risk',
    defaultValue: 0,
    minValue: 0,
    maxValue: 1,
    raiseIncrement: 0.1,
  },
});

export const getBaseballPlayerMarketCodesByType = ({ markets, isPitcher, isHitter }) => {
  let marketCodesByType = [];
  if (isPitcher) {
    marketCodesByType = [
      ...marketCodesByType,
      ...['PLAYER_STRIKEOUT_OVER_UNDER', 'PLAYER_RUNS_ALLOWED', 'PLAYER_HITS_ALLOWED'],
    ];
  }
  if (isHitter) {
    marketCodesByType = [
      ...marketCodesByType,
      ...['PLAYER_BASES_OVER_UNDER', 'PLAYER_RUN_OVER_UNDER', 'PLAYER_ON_BASE', 'PLAYER_ON_BASE_TWO_PLUS', 'PLAYER_HOME_RUN', 'PLAYER_HITS_RUNS_RBI', 'PLAYER_HITS', 'PLAYER_RBI_OVER_UNDER', 'PLAYER_WALKS', 'PLAYER_SINGLES'],
    ];
  }

  return filter(markets, (market) => includes(marketCodesByType, market.marketCode));
};

// TENNIS
export const createTennisGlobalParams = () => ({
  holdPointVariance: {
    shortName: 'holdPointVariance',
    longName: 'Hold point variance',
    defaultValue: 0.005,
    raiseIncrement: 0.001,
    minValue: 0,
    maxValue: 10,
    numberOfDecimals: 4,
    showOnMultiviewList: true,
  },
  homeCoinFlipProb: {
    shortName: 'homeCoinFlipProb',
    longName: 'Home coin flip probability',
    defaultValue: 0.005,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 10,
    numberOfDecimals: 4,
    showOnMultiviewList: true,
  },
  marketCoverage: {
    shortName: 'Market coverage',
    longName: 'Market coverage',
    options: [
      {
        label: 'None',
        value: 'NONE',
      },
      {
        label: 'Result',
        value: 'RESULT',
      },
      {
        label: 'Result / game',
        value: 'RESULT_GAME',
      },
      {
        label: 'Result / handicap',
        value: 'RESULT_HANDICAP_TOTAL',
      },
      {
        label: 'Full',
        value: 'FULL',
      },
    ],
    type: 'text-toggle',
    disabled: true,
  },
});
export const createTennisHomeTeamParams = () => ({
  homeHoldPointPercentagePlayerA: {
    shortName: 'homeHoldPointPercentage',
    longName: 'Home hold point percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.05,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeSecondServeAdjustmentPlayerA: {
    shortName: 'homeSecondServeAdjustment',
    longName: 'Home second serve adjustment',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeAcePercentagePlayerA: {
    shortName: 'homeAcePercentage',
    longName: 'Home ace percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeDoubleFaultPercentagePlayerA: {
    shortName: 'homeDoubleFaultPercentage',
    longName: 'Home double fault percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
});
export const createTennisAwayTeamParams = () => ({
  awayHoldPointPercentagePlayerA: {
    shortName: 'awayHoldPointPercentage',
    longName: 'Away hold point percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.05,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awaySecondServeAdjustmentPlayerA: {
    shortName: 'awaySecondServeAdjustment',
    longName: 'Away second serve adjustment',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayAcePercentagePlayerA: {
    shortName: 'awayAcePercentage',
    longName: 'Away ace percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayDoubleFaultPercentagePlayerA: {
    shortName: 'awayDoubleFaultPercentage',
    longName: 'Away double fault percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
});
export const createTennisDoublesHomeTeamParams = () => ({
  homeHoldPointPercentagePlayerA: {
    shortName: '(A) homeHoldPointPercentage',
    longName: '(A) Home hold point percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.05,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeSecondServeAdjustmentPlayerA: {
    shortName: '(A) homeSecondServeAdjustment',
    longName: '(A) Home second serve adjustment',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeAcePercentagePlayerA: {
    shortName: '(A) homeAcePercentage',
    longName: '(A) Home ace percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeDoubleFaultPercentagePlayerA: {
    shortName: '(A) homeDoubleFaultPercentage',
    longName: '(A) Home double fault percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeHoldPointPercentagePlayerB: {
    shortName: '(B) homeHoldPointPercentage',
    longName: '(B) Home hold point percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.05,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeSecondServeAdjustmentPlayerB: {
    shortName: '(B) homeSecondServeAdjustment',
    longName: '(B) Home second serve adjustment',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeAcePercentagePlayerB: {
    shortName: '(B) homeAcePercentage',
    longName: '(B) Home ace percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  homeDoubleFaultPercentagePlayerB: {
    shortName: '(B) homeDoubleFaultPercentage',
    longName: '(B) Home double fault percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
});
export const createTennisDoublesAwayTeamParams = () => ({
  awayHoldPointPercentagePlayerA: {
    shortName: '(A) awayHoldPointPercentage',
    longName: '(A) Away hold point percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.05,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awaySecondServeAdjustmentPlayerA: {
    shortName: '(A) awaySecondServeAdjustment',
    longName: '(A) Away second serve adjustment',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayAcePercentagePlayerA: {
    shortName: '(A) awayAcePercentage',
    longName: '(A) Away ace percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayDoubleFaultPercentagePlayerA: {
    shortName: '(A) awayDoubleFaultPercentage',
    longName: '(A) Away double fault percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayHoldPointPercentagePlayerB: {
    shortName: '(B) awayHoldPointPercentage',
    longName: '(B) Away hold point percentage',
    defaultValue: 0.3,
    raiseIncrement: 0.05,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awaySecondServeAdjustmentPlayerB: {
    shortName: '(B) awaySecondServeAdjustment',
    longName: '(B) Away second serve adjustment',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayAcePercentagePlayerB: {
    shortName: '(B) awayAcePercentage',
    longName: '(B) Away ace percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
  awayDoubleFaultPercentagePlayerB: {
    shortName: '(B) awayDoubleFaultPercentage',
    longName: '(B) Away double fault percentage',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 10,
    isMain: true,
    showOnMultiviewList: true,
  },
});
const tennisParamsManagerMarkets = () => ([
  {
    label: 'Match',
    marketCode: 'RESULT',
    order: 1,
  },
  {
    label: 'Game Spread',
    marketCode: 'GAME_HANDICAP',
    acceptNegative: true,
    order: 2,
  },
  {
    label: 'Total Games',
    marketCode: 'GAME_OVER_UNDER',
    order: 3,
  },
  {
    label: 'First Set Winner',
    marketCode: 'SET_RESULT',
    order: 4,
    params: {
      PERIOD: 1,
    },
  },
  {
    label: 'Set Spread',
    marketCode: 'SET_HANDICAP',
    acceptNegative: true,
    order: 5,
  },
  {
    label: 'Set Total Games',
    marketCode: 'SET_OVER_UNDER',
    order: 6,
  },
]);

// SOCCER
export const createSoccerGlobalParams = () => ({
  cardShareFirstHalf: {
    shortName: 'cardShareFirstHalf',
    longName: 'Card share first half',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  cardShareHome: {
    shortName: 'cardShareHome',
    longName: 'Card share home',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  cornerShareFirstHalf: {
    shortName: 'cornerShareFirstHalf',
    longName: 'Corner share first half',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  cornerShareHome: {
    shortName: 'cornerShareHome',
    longName: 'Corner share home',
    defaultValue: 1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    showOnMultiviewList: true,
  },
  cornersMatch: {
    shortName: 'cornersMatch',
    longName: 'Corners match',
    defaultValue: 10,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 50,
    showOnMultiviewList: true,
  },
  drawBoost: {
    shortName: 'drawBoost',
    longName: 'Draw boost',
    defaultValue: 0.5,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 2,
    showOnMultiviewList: true,
  },
  drawBoostET: {
    shortName: 'drawBoostET',
    longName: 'Draw boost ET',
    defaultValue: 0.5,
    raiseIncrement: 0.01,
    minValue: 0.5,
    maxValue: 2,
    showOnMultiviewList: true,
  },
  goalShareFirstHalf: {
    shortName: 'goalShareFirstHalf',
    longName: 'Goal share first half',
    defaultValue: 0.1,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  penaltyProbability: {
    shortName: 'penaltyProbability',
    longName: 'Penalty probability',
    defaultValue: 0.01,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 0.5,
    numberOfDecimals: 4,
  },
  redCardShare: {
    shortName: 'redCardShare',
    longName: 'Red card share',
    defaultValue: 0.01,
    raiseIncrement: 0.005,
    minValue: 0,
    maxValue: 0.5,
  },
  yellowCardsMatch: {
    shortName: 'yellowCardsMatch',
    longName: 'Yellow cards match',
    defaultValue: 5,
    raiseIncrement: 0.5,
    minValue: 0,
    maxValue: 30,
  },
  // Override Settings
  overrideEventState: {
    shortName: 'overrideEventState',
    longName: 'Override Event State',
    defaultValue: false,
    type: 'boolean',
    showOnMultiviewList: false,
  },
  overrideCompetitionType: {
    shortName: 'rules',
    longName: 'Override Competition Type',
    defaultValue: 'FIFA_KO_SINGLE_LEG',
    type: 'text-toggle',
    options: [
      { value: 'FIFA_KO_SINGLE_LEG', label: 'Single Leg' },
      { value: 'FIFA_KO_TWO_LEGS', label: 'Double Leg' },
      { value: 'FIFA_KO_PENALTIES', label: 'Straight To Penalties' },
    ],
    showOnMultiviewList: false,
    conditionalDisplay: 'overrideEventState',
  },
  overrideSecondLeg: {
    shortName: 'overrideSecondLeg',
    longName: 'Is Second Leg?',
    defaultValue: false,
    type: 'boolean',
    showOnMultiviewList: false,
    conditionalDisplay: 'overrideEventState',
  },
  overrideHomeScoreFirstLeg: {
    shortName: 'home',
    longName: 'Home Score First Leg',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 9,
    showOnMultiviewList: false,
    conditionalDisplay: 'overrideSecondLeg',
  },
  overrideAwayScoreFirstLeg: {
    shortName: 'away',
    longName: 'Away Score First Leg',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 9,
    showOnMultiviewList: false,
    conditionalDisplay: 'overrideSecondLeg',
  },
  meanScoreDiffSecondLeg: {
    shortName: 'meanScoreDiffSecondLeg',
    longName: 'Mean score diff second leg',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: -10,
    maxValue: 10,
    acceptNegative: true,
  },
  injuryTimeOffsetSeconds: {
    shortName: 'injuryTimeOffsetSeconds',
    longName: 'Injury time offset in seconds',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: -300,
    maxValue: 1800,
    readonly: true,
  },
  injuryTimeDuration: {
    shortName: 'injuryTimeDuration',
    longName: 'Injury time duration in seconds',
    defaultValue: 0,
    raiseIncrement: 1,
    minValue: 0,
    maxValue: 1800,
    readonly: true,
    readFromEventState: true,
  },
});

export const soccerOverrideParamKeys = [
  'overrideEventState',
  'overrideCompetitionType',
  'overrideSecondLeg',
  'overrideHomeScoreFirstLeg',
  'overrideAwayScoreFirstLeg',
];

export const createSoccerHomeTeamParams = () => ({
  loseBoostHome: {
    shortName: 'loseBoostHome',
    longName: 'Lose boost Home',
    defaultValue: 0.5,
    raiseIncrement: 0.05,
    minValue: 0.5,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  redCardScoreRateFactorHome10v9: {
    shortName: 'redCardScoreRateFactorHome10v9',
    longName: 'Red card score rate factor Home 10v9',
    defaultValue: 1,
    raiseIncrement: 0.05,
    minValue: 1,
    maxValue: 5,
    isMain: true,
    showOnMultiviewList: true,
  },
  redCardScoreRateFactorHome11v10: {
    shortName: 'redCardScoreRateFactorHome11v10',
    longName: 'Red card score rate factor Home 11v10',
    defaultValue: 1,
    raiseIncrement: 0.05,
    minValue: 1,
    maxValue: 5,
    isMain: true,
    showOnMultiviewList: true,
  },
  redCardScoreRateFactorHome11v9: {
    shortName: 'redCardScoreRateFactorHome11v9',
    longName: 'Red card score rate factor Home 11v9',
    defaultValue: 1,
    raiseIncrement: 0.05,
    minValue: 1,
    maxValue: 5,
    isMain: true,
    showOnMultiviewList: true,
  },
  scoreRateHome: {
    shortName: 'scoreRateHome',
    longName: 'Score rate Home',
    defaultValue: 0.01,
    raiseIncrement: 0.0002,
    minValue: 0,
    maxValue: 0.1,
    isMain: true,
    showOnMultiviewList: true,
    numberOfDecimals: 4,
  },
  winBoostHome: {
    shortName: 'winBoostHome',
    longName: 'Win boost Home',
    defaultValue: 0.5,
    raiseIncrement: 0.05,
    minValue: 0.5,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  penaltyConversionRateHome: {
    shortName: 'penaltyConversionRateHome',
    longName: 'Penalty conversion rate Home',
    defaultValue: 0.75,
    raiseIncrement: 0.01,
    minValue: 0.25,
    maxValue: 0.95,
    isMain: true,
    showOnMultiviewList: true,
  },
  scoreRateHomeET: {
    shortName: 'ETscoreRateHome',
    longName: 'ET Score rate Home',
    defaultValue: 0.75,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    isMain: true,
    showOnMultiviewList: true,
  },
});

export const createSoccerAwayTeamParams = () => ({
  loseBoostAway: {
    shortName: 'loseBoostAway',
    longName: 'Lose boost Away',
    defaultValue: 0.5,
    raiseIncrement: 0.05,
    minValue: 0.5,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  redCardScoreRateFactorAway10v9: {
    shortName: 'redCardScoreRateFactorAway10v9',
    longName: 'Red card score rate factor Away 10v9',
    defaultValue: 1,
    raiseIncrement: 0.05,
    minValue: 1,
    maxValue: 5,
    isMain: true,
    showOnMultiviewList: true,
  },
  redCardScoreRateFactorAway11v10: {
    shortName: 'redCardScoreRateFactorAway11v10',
    longName: 'Red card score rate factor Away 11v10',
    defaultValue: 1,
    raiseIncrement: 0.05,
    minValue: 1,
    maxValue: 5,
    isMain: true,
    showOnMultiviewList: true,
  },
  redCardScoreRateFactorAway11v9: {
    shortName: 'redCardScoreRateFactorAway11v9',
    longName: 'Red card score rate factor Away 11v9',
    defaultValue: 1,
    raiseIncrement: 0.05,
    minValue: 1,
    maxValue: 5,
    isMain: true,
    showOnMultiviewList: true,
  },
  scoreRateAway: {
    shortName: 'scoreRateAway',
    longName: 'Score rate Away',
    defaultValue: 0.01,
    raiseIncrement: 0.0002,
    minValue: 0,
    maxValue: 0.1,
    isMain: true,
    showOnMultiviewList: true,
    numberOfDecimals: 4,
  },
  winBoostAway: {
    shortName: 'winBoostAway',
    longName: 'Win boost Away',
    defaultValue: 0.5,
    raiseIncrement: 0.05,
    minValue: 0.5,
    maxValue: 2,
    isMain: true,
    showOnMultiviewList: true,
  },
  penaltyConversionRateAway: {
    shortName: 'penaltyConversionRateAway',
    longName: 'Penalty conversion rate Away',
    defaultValue: 0.75,
    raiseIncrement: 0.01,
    minValue: 0.25,
    maxValue: 0.95,
    isMain: true,
    showOnMultiviewList: true,
  },
  scoreRateAwayET: {
    shortName: 'ETscoreRateAway',
    longName: 'ET Score rate Away',
    defaultValue: 0.75,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
    isMain: true,
    showOnMultiviewList: true,
  },
});
const soccerParamsManagerMarkets = () => ([
  {
    label: 'Result 1X2',
    marketCode: 'RESULT',
    order: 1,
  },
  {
    label: 'Goal Spread',
    marketCode: 'GOAL_HANDICAP',
    acceptNegative: true,
    order: 3,
  },
  {
    label: 'Total Goals',
    marketCode: 'GOAL_OVER_UNDER',
    order: 4,
  },
]);

export const createSoccerPlayerParams = () => ({
  goals: {
    key: 'goals',
    shortName: 'Goals',
    longName: 'Goals',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  assists: {
    key: 'assists',
    shortName: 'Assists',
    longName: 'Assists',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  totalShots: {
    key: 'totalShots',
    shortName: 'Total Shots',
    longName: 'Total Shots',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  shotsOnTarget: {
    key: 'shotsOnTarget',
    shortName: 'Shots on Target',
    longName: 'Shots on Target',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  totalPasses: {
    key: 'totalPasses',
    shortName: 'Total Passes',
    longName: 'Total Passes',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 0.5,
  },
  accuratePasses: {
    key: 'accuratePasses',
    shortName: 'Accurate Passes',
    longName: 'Accurate Passes',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  tackles: {
    key: 'tackles',
    shortName: 'Tackles',
    longName: 'Tackles',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  interceptions: {
    key: 'interceptions',
    shortName: 'Interceptions',
    longName: 'Interceptions',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  offsides: {
    key: 'offsides',
    shortName: 'Offsides',
    longName: 'Offsides',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  fouls: {
    key: 'fouls',
    shortName: 'Fouls',
    longName: 'Fouls',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  saves: {
    key: 'saves',
    shortName: 'Saves',
    longName: 'Saves',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  accurateCrosses: {
    key: 'accurateCrosses',
    shortName: 'Accurate Crosses',
    longName: 'Accurate Crosses',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  totalCrosses: {
    key: 'totalCrosses',
    shortName: 'Total Crosses',
    longName: 'Total Crosses',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  minutes: {
    key: 'minutes',
    shortName: 'Minutes',
    longName: 'Minutes',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  penalty: {
    key: 'penalty',
    shortName: 'Penalty',
    longName: 'Penalty',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  yellowCards: {
    key: 'yellowCards',
    shortName: 'Yellow Cards',
    longName: 'Yellow Cards',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
  redCards: {
    key: 'redCards',
    shortName: 'Red Cards',
    longName: 'Red Cards',
    defaultValue: 0,
    raiseIncrement: 0.01,
    minValue: 0,
    maxValue: 1,
  },
});

// MAPPERS
export const getGlobalParamsConfigBySport = (sportId, modelType) => {
  let globalParamsConfig = {};

  switch (sportId) {
  case HOCKEY_ID: {
    globalParamsConfig = createHockeyGlobalParams();
    break;
  }
  case BASKETBALL_ID: {
    globalParamsConfig = modelType === 'cruncher' ? createBasketballCruncherGlobalParams() : createBasketballRandomWalkGlobalParams();
    break;
  }
  case FOOTBALL_ID: {
    globalParamsConfig = createFootballGlobalParams();
    break;
  }
  case BASEBALL_ID: {
    globalParamsConfig = createBaseballGlobalParams();
    break;
  }
  case TENNIS_ID: {
    globalParamsConfig = createTennisGlobalParams();
    break;
  }
  case SOCCER_ID: {
    globalParamsConfig = createSoccerGlobalParams();
    break;
  }
  default: globalParamsConfig = null;
  }

  return globalParamsConfig;
};

export const getTeamParamsConfigBySport = (sportId, modelType, doubles = false) => {
  let teamParamsConfig = {};

  switch (sportId) {
  case HOCKEY_ID: {
    teamParamsConfig = {
      ...createHockeyHomeTeamParams(),
      ...createHockeyAwayTeamParams(),
    };
    break;
  }
  case FOOTBALL_ID: {
    teamParamsConfig = {
      ...createFootballHomeTeamParams(),
      ...createFootballAwayTeamParams(),
    };
    break;
  }
  case BASKETBALL_ID: {
    teamParamsConfig = {
      ...(modelType === 'cruncher' ? createBasketballCruncherHomeTeamParams() : createBasketballRandomWalkHomeTeamParams()),
      ...(modelType === 'cruncher' ? createBasketballCruncherAwayTeamParams() : createBasketballRandomWalkAwayTeamParams()),
    };
    break;
  }
  case BASEBALL_ID: {
    teamParamsConfig = merge({}, createBaseballHomeTeamParams(), createBaseballAwayTeamParams());
    break;
  }
  case TENNIS_ID: {
    if (doubles) {
      teamParamsConfig = {
        ...createTennisDoublesHomeTeamParams(),
        ...createTennisDoublesAwayTeamParams(),
      };
    } else {
      teamParamsConfig = {
        ...createTennisHomeTeamParams(),
        ...createTennisAwayTeamParams(),
      };
    }
    break;
  }
  case SOCCER_ID: {
    teamParamsConfig = {
      ...createSoccerHomeTeamParams(),
      ...createSoccerAwayTeamParams(),
    };
    break;
  }
  default: teamParamsConfig = null;
  }
  return teamParamsConfig;
};

export const getObjectMappableKeys = (obj, mappableKeys = [], mappableKey = '', nonMappable = false) => {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      getObjectMappableKeys(obj[key], mappableKeys, !mappableKey ? key : `${mappableKey}.${key}`, obj[key]?.nonMappable);
    } else if (!includes(mappableKeys, mappableKey) && !nonMappable) {
      mappableKeys.push(mappableKey);
    }
  });
  return mappableKeys?.length ? mappableKeys : null;
};

const mapParamsSetupBaseballGameParams = (gameParams, gameParamsConfig, paramsDefaultOrProjected) => reduce(
  gameParamsConfig,
  (allParams, paramConfig, key) => {
    const paramsToAdd = {};
    const objectMappableKeys = getObjectMappableKeys(paramConfig, [], key);
    forEach(objectMappableKeys, (mappableKey) => {
      const param = get(gameParamsConfig, mappableKey);
      const customMappableKey = param?.customMappableKey;
      const paramValue = customMappableKey ? get(gameParams, customMappableKey) : get(gameParams, mappableKey);
      const isError = (typeof paramValue === 'number') && (paramValue < param?.minValue || paramValue > param?.maxValue) && !param.readonly;
      const errorMessage = `${param?.shortName} must be a value between ${param?.minValue} and ${param?.maxValue}`;
      const paramValueFormatted = (paramValue && typeof paramValue === 'number') ? parseFloat((paramValue).toFixed(param.numberOfDecimals || 3)) : paramValue;
      set(paramsToAdd, mappableKey, ({
        ...param,
        value: paramValueFormatted,
        isError,
        errorMessage,
        originalValue: paramsDefaultOrProjected ? null : paramValueFormatted,
        mappableKey,
      }
      ));
    });
    return {
      ...allParams,
      ...paramsToAdd,
    };
  }, {},
);

const isTennisDoubles = (gameParams) => {
  if (!gameParams) return false;
  return some(keys(gameParams), (key) => key.includes('PlayerB'));
};

export const mapPlayerSetupGameParams = (gameParams, sportId, paramsDefaultOrProjected, eventState) => {
  if (!gameParams) return null;
  const doubles = sportId === TENNIS_ID ? isTennisDoubles(gameParams) : false;
  const gameParamsConfig = {
    ...getGlobalParamsConfigBySport(sportId, gameParams?.modelType) || {},
    ...getTeamParamsConfigBySport(sportId, gameParams?.modelType, doubles) || {},
  };

  // For baseball
  if (sportId === BASEBALL_ID) {
    return mapParamsSetupBaseballGameParams(gameParams, gameParamsConfig, paramsDefaultOrProjected);
  }

  // For hockey, basketball and football
  const gameParamsMapped = [];
  const gameParamsKeys = keys(gameParamsConfig);
  forEach(gameParamsKeys, (paramKey) => {
    const param = cloneDeep(gameParamsConfig[paramKey]);
    let paramValue = gameParams[paramKey];
    if (param.readFromEventState && eventState) {
      const eventStateValue = get(eventState, paramKey);
      if (eventStateValue) {
        paramValue = eventStateValue;
      }
    }
    if (paramKey === 'overrideRemainingTimeInQuarterSeconds') {
      param.maxValue = getFootballOverrideRemainingTimeMax(gameParams.overrideQuarter);
    }
    const isError = (typeof paramValue === 'number') && (paramValue < param?.minValue || paramValue > param?.maxValue);
    const errorMessage = `${param?.shortName} must be a value between ${param?.minValue} and ${param?.maxValue}`;
    const paramValueFormatted = (paramValue && typeof paramValue === 'number') ? parseFloat((paramValue).toFixed(param.numberOfDecimals || 3)) : paramValue;
    gameParamsMapped.push({
      value: paramValueFormatted,
      originalValue: paramsDefaultOrProjected ? null : paramValueFormatted,
      isError,
      errorMessage,
      key: paramKey,
      ...param,
    });
  });

  return gameParamsMapped;
};

export const mapPlayerSetupGameParamsSocketUpdate = (gameParams, updatedGameParams) => reduce(
  gameParams,
  (allParams, param) => {
    const paramCopy = cloneDeep(param);
    const paramValue = updatedGameParams[param.key];
    const newVal = (paramValue && typeof paramValue === 'number') ? parseFloat((paramValue).toFixed(param.numberOfDecimals || 3)) : paramValue;
    paramCopy.value = newVal;
    paramCopy.originalValue = newVal;
    paramCopy.isError = (typeof newVal === 'number') && (newVal < paramCopy?.minValue || newVal > paramCopy?.maxValue);

    return [
      ...allParams,
      ...[paramCopy],
    ];
  }, [],
);

export const mapPlayerSetupGameParamsSubmitPayload = (gameParams, sportId) => {
  const paramsForPayload = reduce(gameParams,
    (allParams, param) => ({
      ...allParams,
      ...{ [param.key]: param.value },
    }), {});

  if (sportId === FOOTBALL_ID) {
    // For AF if overrideEventState is true, we need to send all the params
    // If not we should delete override params
    if (!paramsForPayload.overrideEventState) {
      delete paramsForPayload.overrideDownNumber;
      delete paramsForPayload.overrideYardsToWinDown;
      delete paramsForPayload.overrideYardsToEndZone;
      delete paramsForPayload.overridePossession;
      delete paramsForPayload.overrideQuarter;
      delete paramsForPayload.overrideRemainingTimeInQuarterSeconds;
      delete paramsForPayload.overrideHomeTimeouts;
      delete paramsForPayload.overrideAwayTimeouts;
    } else if (!paramsForPayload.overridePossession) {
      // If no value for is set for overridePossession, we should set it to NEUTRAL
      paramsForPayload.overridePossession = 'NEUTRAL';
    }
  } else if (sportId === SOCCER_ID) {
    paramsForPayload.modelType = 'cruncher';
  }
  return paramsForPayload;
};

export const mapPlayerSetupBaseballGameParams = (obj, result = {}) => {
  forEach(toPairs(obj), (pair) => {
    const val = pair[1];
    if (isObject(val) && val.mappableKey) {
      const { customMappableKey } = val;
      if (customMappableKey) {
        set(result, customMappableKey, val.value);
      } else {
        set(result, val.mappableKey, val.value);
      }
    }
    if (isObject(val)) {
      mapPlayerSetupBaseballGameParams(val, result);
    }
  });
  return result;
};

// HELPERS
export const getGlobalParamsKeysBySport = (sportId, modelType) => {
  let globalParamsConfig = {};
  switch (sportId) {
  case HOCKEY_ID: {
    globalParamsConfig = createHockeyGlobalParams();
    break;
  }
  case BASKETBALL_ID: {
    globalParamsConfig = modelType === 'cruncher' ? createBasketballCruncherGlobalParams() : createBasketballRandomWalkGlobalParams();
    break;
  }
  case FOOTBALL_ID: {
    globalParamsConfig = createFootballGlobalParams();
    break;
  }
  case BASEBALL_ID: {
    globalParamsConfig = createBaseballGlobalParams();
    break;
  }
  case TENNIS_ID: {
    globalParamsConfig = createTennisGlobalParams();
    break;
  }
  case SOCCER_ID: {
    globalParamsConfig = createSoccerGlobalParams();
    break;
  }
  default: globalParamsConfig = null;
  }

  return keys(globalParamsConfig) || [];
};

export const getTeamParamsKeysByTeamAndSport = (teamLabel, sportId, modelType, doubles = false) => {
  let globalParamsConfig = {};
  if (!teamLabel) return [];

  switch (sportId) {
  case HOCKEY_ID: {
    globalParamsConfig = teamLabel === 'Home' ? createHockeyHomeTeamParams() : createHockeyAwayTeamParams();
    break;
  }
  case FOOTBALL_ID: {
    globalParamsConfig = teamLabel === 'Home' ? createFootballHomeTeamParams() : createFootballAwayTeamParams();
    break;
  }

  case BASKETBALL_ID: {
    // eslint-disable-next-line no-nested-ternary
    globalParamsConfig = teamLabel === 'Home'
      ? (modelType === 'cruncher' ? createBasketballCruncherHomeTeamParams() : createBasketballRandomWalkHomeTeamParams())
      : (modelType === 'cruncher' ? createBasketballCruncherAwayTeamParams() : createBasketballRandomWalkAwayTeamParams());
    break;
  }
  case TENNIS_ID: {
    if (doubles) {
      globalParamsConfig = teamLabel === 'Home' ? createTennisDoublesHomeTeamParams() : createTennisDoublesAwayTeamParams();
      break;
    }
    // For singles
    globalParamsConfig = teamLabel === 'Home' ? createTennisHomeTeamParams() : createTennisAwayTeamParams();
    break;
  }
  case SOCCER_ID: {
    globalParamsConfig = teamLabel === 'Home' ? createSoccerHomeTeamParams() : createSoccerAwayTeamParams();
    break;
  }
  default: globalParamsConfig = null;
  }

  return keys(globalParamsConfig) || [];
};

const findAvailableMarket = (availableMarkets, market) => find(availableMarkets, (allMarketsItem) => (
  allMarketsItem.marketCode === market.marketCode
  && allMarketsItem.params?.TEAM === market.params?.TEAM
  && allMarketsItem.params?.PERIOD === market.params?.PERIOD
  && allMarketsItem.params?.HALF === market.params?.HALF));

export const getParamsManagerMarketsBySport = (availableMarkets, sportId, isUSAView) => {
  let marketsBySport = [];

  switch (sportId) {
  case HOCKEY_ID: {
    marketsBySport = hockeyParamsManagerMarkets(isUSAView);
    break;
  }
  case BASKETBALL_ID: {
    marketsBySport = basketballParamsManagerMarkets(isUSAView);
    break;
  }
  case FOOTBALL_ID: {
    marketsBySport = footballParamsManagerMarkets(isUSAView);
    break;
  }
  case BASEBALL_ID: {
    marketsBySport = baseballParamsManagerMarkets(isUSAView);
    break;
  }
  case TENNIS_ID: {
    marketsBySport = tennisParamsManagerMarkets();
    break;
  }
  case SOCCER_ID: {
    marketsBySport = soccerParamsManagerMarkets();
    break;
  }
  default: marketsBySport = null;
  }
  marketsBySport = reduce(marketsBySport, (availableMarketsBySport, market) => {
    const foundMarket = findAvailableMarket(availableMarkets, market);
    if (!foundMarket) return availableMarketsBySport;
    return [
      ...availableMarketsBySport,
      {
        ...market,
        ...foundMarket,
      },
    ];
  }, []);
  return orderBy(marketsBySport, 'order');
};

export const isBaseballGameParamsError = (params) => some(params, (val) => {
  if (isObject(val)) {
    return val.isError === true || isBaseballGameParamsError(val);
  }
  return false;
});

export const isBaseballGameParamsChanged = (params) => some(params, (val) => {
  if (isObject(val)) {
    return (val.value !== val.originalValue) || isBaseballGameParamsChanged(val);
  }
  return false;
});

const mapBaseballGameParamsAfterSubmit = (params) => reduce(
  params,
  (syncedParams, val, key) => {
    if (isObject(val) && val.mappableKey) {
      return {
        ...syncedParams,
        [key]: {
          ...val,
          originalValue: val.value,
        },
      };
    }
    if (isObject(val)) {
      return {
        ...syncedParams,
        [key]: mapBaseballGameParamsAfterSubmit(val),
      };
    }
    return {
      ...syncedParams,
      [key]: val,
    };
  },
  {},
);

// Baselines game params original values after a successful submit.
export const mapPlayerSetupGameParamsAfterSubmit = (gameParams, isBaseball = false) => {
  if (!gameParams) return gameParams;
  if (isBaseball) return mapBaseballGameParamsAfterSubmit(gameParams);
  return map(gameParams, (param) => ({
    ...param,
    originalValue: param.value,
  }));
};

// Helper function that will reorder the players position value when a player is moved
export const updateTeamPlayersPositionValue = (players, updatedPlayerId, updatedPlayerValue, oldValue) => {
  if (!updatedPlayerValue) return players;
  const hasPlayerWithSamePosition = !!find(players, (player) => player.playerPositionIndex === updatedPlayerValue);
  if (!hasPlayerWithSamePosition) return players;
  const playersDataByTeam = cloneDeep(players);

  const valueIncremented = updatedPlayerValue > oldValue;
  // If the value is decremented we only switch the value of the the player that has the same value as the changed one, with the previous value of the changed player
  // This is the case only when the difference between the old value and the updated value is 1
  if (!valueIncremented && oldValue - updatedPlayerValue === 1) {
    const playerToUpdateIndex = findIndex(playersDataByTeam, (player) => player.playerPositionIndex === updatedPlayerValue);
    playersDataByTeam[playerToUpdateIndex] = {
      ...playersDataByTeam[playerToUpdateIndex],
      playerPositionIndex: oldValue,
    };
    return playersDataByTeam;
  }
  // If the value is incremented we need to increment the value of all the players that are between the updated player and the next player with a higher value
  // We update all the players with the highter value until we find a player with a value that is not consecutive
  let playersToUpdate = orderBy(
    filter(
      playersDataByTeam,
      (player) => player.playerId !== updatedPlayerId
      && player.playerPositionIndex >= updatedPlayerValue,
    ), 'playerPositionIndex',
  );
  const endIndex = findIndex(playersToUpdate, ({ playerPositionIndex }, i) => playersToUpdate[i + 1]?.playerPositionIndex - playerPositionIndex > 1);
  if (endIndex !== -1) {
    playersToUpdate = playersToUpdate.slice(0, endIndex + 1);
  }
  const playersToUpdateIds = map(playersToUpdate, 'playerId');
  forEach(playersToUpdateIds, (playerId) => {
    const playerIndex = findIndex(playersDataByTeam, (player) => player.playerId === playerId);
    const playerData = cloneDeep(playersDataByTeam[playerIndex]);
    playersDataByTeam[playerIndex] = {
      ...playerData,
      playerPositionIndex: playerData.playerPositionIndex + 1,
    };
  });
  return playersDataByTeam;
};

export const mapGameParamsFromEventState = (gameParams, eventState) => {
  if (!gameParams?.length) {
    return { isGameParamsChanged: false, gameParamsUpdated: gameParams };
  }
  const hasReadableParams = some(gameParams, (param) => param.readFromEventState);
  if (!hasReadableParams) {
    return { isGameParamsChanged: false, gameParamsUpdated: gameParams };
  }

  let isGameParamsChanged = false;
  const gameParamsUpdated = map(gameParams, (param) => {
    if (!param.readFromEventState) return param;
    const value = get(eventState, param.key);
    if (param.value === value) return param;
    isGameParamsChanged = true;
    return { ...param, value };
  });

  return {
    isGameParamsChanged,
    gameParamsUpdated: isGameParamsChanged ? gameParamsUpdated : gameParams,
  };
};
